import { Component, computed, input } from "@angular/core";
import { CouponData } from "../../models/interfaces/coupons.interface";
import { MOCK_COUPONS } from "./coupon.data";
import { DialogFactory } from "../../components/dialog/dialogFactory";

@Component({
  selector: "app-coupons",
  templateUrl: "./coupon.component.html",
  host: {
    class: "tw-block tw-w-full tw-h-full",
  },
})
export class CouponsComponent {
  private dialogFactory: DialogFactory = new DialogFactory();

  // Undefined (e.g. inside the "browse all" slide-out) shows every coupon.
  limit = input<number | undefined>(6);

  // Set when rendered inside another dialog (e.g. "browse all coupons"): coupon
  // details open on top of that dialog, so closing them goes back to the list.
  parentDialogFactory = input<DialogFactory | undefined>(undefined);

  coupons: CouponData[] = MOCK_COUPONS;

  readonly visibleCoupons = computed<CouponData[]>(() => {
    const limit = this.limit();
    return limit != null ? this.coupons.slice(0, limit) : this.coupons;
  });

  readonly hasMore = computed<boolean>(() => {
    const limit = this.limit();
    return limit != null && this.coupons.length > limit;
  });

  onCouponRedeem(event: { couponId: string }): void {
    const selectedCoupon = this.coupons.find((c) => c.id === event.couponId);
    if (selectedCoupon) {
      const parentDialogFactory = this.parentDialogFactory();
      if (parentDialogFactory) {
        parentDialogFactory.openCouponDetailsDialog(selectedCoupon, true);
      } else {
        this.dialogFactory.openCouponDetailsDialog(selectedCoupon);
      }
    }
  }

  browseAllCoupons(): void {
    this.dialogFactory.openBrowseAllCouponsDialog();
  }
}
